var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgbtqia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64192",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.9667 15 13.7917 14.6583 14.475 13.975C15.1583 13.2917 15.5 12.4667 15.5 11.5C15.5 10.5333 15.1583 9.70833 14.475 9.025C13.7917 8.34167 12.9667 8 12 8C11.0333 8 10.2083 8.34167 9.525 9.025C8.84167 9.70833 8.5 10.5333 8.5 11.5C8.5 12.4667 8.84167 13.2917 9.525 13.975C10.2083 14.6583 11.0333 15 12 15ZM11 23V21H9V19H11V16.9C9.7 16.6667 8.625 16.0417 7.775 15.025C6.925 14.0083 6.5 12.8333 6.5 11.5C6.5 10.95 6.57917 10.4083 6.7375 9.875C6.89583 9.34167 7.13333 8.85 7.45 8.4L6.8 7.75L5.4 9.15L4 7.75L5.4 6.325L3.5 4.425V7H1.5V1H7.5V3H4.925L6.825 4.9L8.25 3.5L9.65 4.9L8.25 6.325L8.9 6.975C9.35 6.64167 9.84167 6.39583 10.375 6.2375C10.9083 6.07917 11.45 6 12 6C12.55 6 13.0917 6.07917 13.625 6.2375C14.1583 6.39583 14.65 6.64167 15.1 6.975L19.075 3H16.5V1H22.5V7H20.5V4.425L16.525 8.375C16.8417 8.84167 17.0833 9.3375 17.25 9.8625C17.4167 10.3875 17.5 10.9333 17.5 11.5C17.5 12.8333 17.075 14.0083 16.225 15.025C15.375 16.0417 14.3 16.6667 13 16.9V19H15V21H13V23H11Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgbtqia);
export default __webpack_public_path__ + "static/media/LGBTQIA+.de906e03.svg";
export { ForwardRef as ReactComponent };